import { useAppServices } from "hook/services";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const ContactInfoData = () => {
  const { locationId } = useParams();
  const AppService = useAppServices();
  const [CustomFieldFolders, setCustomFieldFolders] = useState<any[]>([]);
  const [CustomFields, setCustomFields] = useState<any[]>([]);
  const [tags, setTags] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  const getCustomFieldFolders = async () => {
    const { response, error } = await AppService.custom_field.folder.filter({
      query: `locationId=${locationId}`,
    });
    if (response) {
      setCustomFieldFolders(response.data);
      setLoading(false);
    } else {
      setCustomFieldFolders([]);
      setLoading(false);
    }
  };
  const getCustomFields = async () => {
    const { response, error } = await AppService.custom_field.field.filter({
      query: `locationId=${locationId}`,
    });
    if (response) {
      setCustomFields(response.data);
      setLoading(false);
    } else {
      setCustomFields([]);
      setLoading(false);
    }
  };
  const getTags = async () => {
    const { response, error } = await AppService.tag.filter({
      query: `locationId=${locationId}`,
    });
    if (response) {
      setTags(response.data);
      setLoading(false);
    } else {
      setTags([]);
      setLoading(false);
    }
  };
  let pageLoad = true;
  const onload = () => {
    if (pageLoad) {
      getCustomFieldFolders();
      getCustomFields();
      getTags();
      pageLoad = false;
    }
  };

  useEffect(() => {
    onload();
  }, []);
  return {
    loading: loading,
    CustomFieldFolders: CustomFieldFolders,
    CustomFields: CustomFields,
    tags: tags,
  };
};

export default ContactInfoData;
